function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "entry-icon/keyboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2-Copy-2",
  transform: "translate(0.000000, 6.000000)",
  fill: "#1B2559"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-5",
  x: 0,
  y: 12,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-8",
  x: 0,
  y: 24,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-3",
  x: 12,
  y: 1.13686838e-13,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-6",
  x: 12,
  y: 12,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-9",
  x: 12,
  y: 24,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-11",
  x: 64,
  y: 24,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-32",
  x: 52,
  y: 24,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-4",
  x: 24,
  y: 1.13686838e-13,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-26",
  x: 36,
  y: 1.13686838e-13,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-27",
  x: 48,
  y: 1.13686838e-13,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-28",
  x: 60,
  y: 1.13686838e-13,
  width: 12,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-7",
  x: 24,
  y: 12,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-29",
  x: 36,
  y: 12,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-30",
  x: 48,
  y: 12,
  width: 8,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-31",
  x: 60,
  y: 12,
  width: 12,
  height: 8,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-10",
  x: 24,
  y: 24,
  width: 24,
  height: 8,
  rx: 2
})));

function SvgKeyboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "44px",
    viewBox: "0 0 72 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "entry-icon/keyboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.cc22b859.svg";
export { ForwardRef as ReactComponent };